import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=ebdc6d9c&scoped=true&"
import script from "./DeliveryList.vue?vue&type=script&lang=js&"
export * from "./DeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=ebdc6d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdc6d9c",
  null
  
)

export default component.exports